export default "__VITE_ASSET__BmnjCdnQ__"